import React from 'react';
export function ProblemSection() {
  return <section className="bg-sage py-20 md:py-28" data-id="element-107">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-108">
        <div className="bg-white p-8 md:p-12 lg:p-16 rounded-sm shadow-xl relative border-l-4 border-gold" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-8" data-id="element-110">
            El verdadero problema de la inflamación latina
          </h2>

          <div className="space-y-6 text-lg text-dark/80 font-body leading-relaxed" data-id="element-111">
            <p data-id="element-112">
              Para la mujer latina moderna, la inflamación no es solo un tema de
              estética; es un obstáculo que drena tu energía, nubla tu mente y
              te quita la confianza frente al espejo.
            </p>

            <p data-id="element-113">
              Has intentado jugos verdes que te dan más gases, probióticos caros
              que no hacen nada y dietas "gringas" que te piden comer cosas que
              ni siquiera encuentras en tu supermercado o que simplemente no
              saben a nada.
            </p>

            <div className="bg-cream p-6 rounded-sm mt-8 border border-gold/20" data-id="element-114">
              <p className="font-heading text-xl text-forest italic" data-id="element-115">
                "El problema es que esas soluciones no entienden nuestra
                cultura, nuestro sazón, ni lo que realmente sucede en nuestras
                cocinas."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}